import { Component, OnInit, } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContribuicoesProvider } from 'src/app/services/contribuicoes/contribuicoes';
import { Browser } from '@capacitor/browser';
import { format, isBefore, parseISO } from 'date-fns';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { MoneyPipe } from 'src/app/pipes/money/money';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';

@Component({
  selector: 'app-contribuicoes-minhas-parcelas',
  templateUrl: './contribuicoes-minhas-parcelas.page.html',
  styleUrls: ['./contribuicoes-minhas-parcelas.page.scss'], 
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    MoneyPipe,
    SemRegistroComponent
  ],
})
export class ContribuicoesMinhasParcelasPage implements OnInit {
  parcelas: any = [];
  plano: any = {};
  dateToCompare: any = format(new Date(), "yyyy-MM-dd");

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private translate: TranslateService,
    public contribuicoesController: ContribuicoesProvider,
    public loadingController: LoadingController
  ) {
    this.plano = this.navParams.get('plano');
    this.parcelas = this.plano.parcelas;
  }

  ngOnInit() { }

  isAtrasado(data: string) {
    let date = format(parseISO(data), "yyyy-MM-dd");
    const result = isBefore(new Date(date), new Date(this.dateToCompare));
    return result;
  }

  abrirBoleto(idContaReceberParcela: any) {
    this.contribuicoesController.getBoletoParcela(idContaReceberParcela).subscribe(async data => {
      if (!data.error) {
        await Browser.open({ url: data.urlPagamento });

      } else {
        const toast = await this.toastCtrl.create({
          message: this.translate.instant('Ocorreu um erro inesperado'),
          duration: 3000
        });

        toast.present();
      }
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
